<template>
	<div>
		<h1>Merge</h1>
		{{planning}}
		{{mergePlanning}}
	</div>
</template>

<script>
import PlanningService from '@/services/PlanningService'
export default {
	components: {
	},
	data () {
		return {
			planning: {},
			mergePlanning: {}
		}
	},
	methods: {
		async getPlannings () {
			this.mergePlanning = await PlanningService.get(this.$route.params.id)
			// Ensure plannings are always refreshed when Merge is opened
			await this.$store.dispatch('getPlannings')
			// Check if the planning exists amongst local plannings (it should)
			const plannings = this.$store.state.plannings
			const index = plannings.findIndex(planning => planning.Info.Course.id === this.mergePlanning.Info.Course.id)
			// If the user is the owner, get the planning from local storage
			if (index >= 0) this.planning = JSON.parse(JSON.stringify(plannings[index]))
			else this.$router.push('/plannings')
		}
	},
	created () {
		this.getPlannings()
	}
}
</script>

<style>
</style>
